module.exports = __webpack_public_path__ + "static/media/ship_tollaut_logo.dc156671.svg";